const europeCounties = [
  'ITA',
  'IT',
  'FRA',
  'FR',
  'DEU',
  'DE',
  'ESP',
  'ES',
  'PRT',
  'AUT',
  'SWE',
  'NOR',
  'FIN',
  'DNK',
  'NLD',
  'LTU',
  'LVA',
  'EST',
  'BEL',
  'POL',
  'IRL',
  'SVN',
  'LUX',
  'CYP',
  'MLT',
  'FLK',
  'ISL',
  'GRC',
  'SVK',
  'ROU',
  'CZE',
  'CHE',
  'HUN',
  'BGR',
  'SRB',
  'HRV',
  'BIH',
  'MKD',
  'MNE',
  'ALB',
  'AND',
  'IMN',
  'LIE',
  'MDA',
  'MCO',
  'XKX',
  'SMR',
  'SCG'
];

export const getCurrencySymbol = (currency: string | undefined): string => {
  if (currency === 'EUR') return '€';
  if (currency === 'GBP') return '£';
  if (currency === 'JPY') return '¥';

  return '$';
};

export const getCurrencySymbolByCountryCode = (country: string) => {
  if (europeCounties?.includes(country)) return '€';
  if (['GBR']?.includes(country)) return '£';
  if (['JPN']?.includes(country)) return '¥';
  return '$';
};
